export const DOCUMENT_EXTRACTION_ACTION = {
  SKIP: 'Skip',
  REJECT: 'Reject',
  COMPLETE: 'Complete',
};

export const DOCUMENT_EXTRACTION_FIELD_UPDATE_TYPE = {
  TABLE: 'Table',
  ORDINARY: 'Ordinary',
  TABLE_OBJECT: 'TableObject',
};
